import { makeStyles, createStyles } from "@material-ui/styles"

const useStyles = makeStyles(theme =>
  createStyles({
    subContainer: {
      [theme.breakpoints.down("md")]: {
        width: "50%",
      },
    },
    totalNumberBox: {
      backgroundColor: "#FAF7F7",
      padding: theme.spacing(1),
      borderRadius: "5px",
      color: "#00003D",
    },
    totalBox: {
      padding: theme.spacing(1),
      marginBottom: "5px",
    },
    paidBox: {
      padding: theme.spacing(1),
      marginTop: "5px",
      marginBottom: "5px",
      color: "#00003D",
    },
    balanceBox: {
      padding: theme.spacing(1),
      marginTop: "5px",
      marginBottom: "5px",
      color: "#00003D",
    },
    blueTitles: {
      color: "#00003D",
      fontWeight: "bold",
    },
    totalContainer: {
      display: "flex",
      justifyContent: "flex-end",
      [theme.breakpoints.down("xs")]: {
        width: "100%",
        justifyContent: "left",
      },
    },
  })
)

export default useStyles
